<template>
    <main-layout>
        <div class="container has-text-white">
            <H1 class="pageTitle">FORGOT PASSWORD</H1>
           
            <div class="limitWidth top40" v-show="showEnterEmail">
                <div>Please enter the email address you use to log in:</div>
                <form name="form1" class="accSettingsForm top20" v-on:submit.prevent="doForgot" data-vv-scope="form1">
                    <div class="field" :class="{formError: errors.first('form1.email') }">
                        <input type="text" class="input is-warning" name="email" v-validate="'required|email'" v-model="form1.email" />
                        <p class="help is-danger" >
                            {{ errors.first('form1.email') }}
                        </p>
                    </div>
                    <button id="submit1" class="button top10 is-warning" type="submit">SUBMIT</button>
                </form>
            </div>

            <div v-show="backendresend">
                 <div class="bottom10 is-size-4 top20">Please check your email. We sent you a temporary password. After retrieving it, please log in.</div>
                 <button class="button top10 is-warning top10" @click="openLogin">LOGIN</button>

            </div>

            <div class="limitWidth" v-show="showEnterPass">
               <div class="bottom10 top20">A verification code was sent to <span class="has-text-weight-bold">{{form1.email}}</span>. Please enter it and provide the new password you would like to use.</div>
               <form name="form2" v-on:submit.prevent="doCode" data-vv-scope="form2">
                    <div class="field has-text-white" :class="{formError: errors.first('form2.code') }">
                        Code:
                        <input type="text" class="input is-warning has-text-white" name="code"  v-validate="'required'" v-model="form2.code"/>
                        <p class="help is-danger" >
                            {{ errors.first('form2.code') }}
                        </p>
                    </div>
                    <div class="field has-text-white" :class="{formError: errors.first('form2.Pass') }" >
                        New Password:
                        <input class="input is-warning has-text-white" type="password" name="Pass"  data-vv-as="New Password" v-validate="{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}" v-model="form2.pass"/>
                        <p class="help is-danger" >
                            {{ errors.first('form2.Pass') }}
                        </p>
                       
                    </div>
                    <div class="field has-text-white" :class="{formError: errors.first('form2.pass2') }">
                        Confirm Password:
                        <input class="input is-warning has-text-white" type="password" name="pass2" v-validate="{required:true, is: form2.pass}"  data-vv-as="Confirm Password"/>
                        <p class="help is-danger" >
                            {{ errors.first('form2.pass2') }}
                        </p>
                         <span class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)</span>
                    </div>
                    <button id="submit2" class="button top10 is-warning" type="submit">SUBMIT</button>
                </form>
            </div>

            <div class="limitWidth" v-if="showDone">
                <div>Your password was successfullly changed!</div>
                <button class="button top10 is-warning" @click="openLogin">LOGIN</button>
            </div>

            <div class="limitWidth" v-if="showError">
                <div>There was an error changing your password. Please try again.</div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')

export default {
  components: {
    MainLayout
  },
  data: function () {
    var form1 = {email: ''}
    var form2 = {code: '', pass: '', pass2: ''}
    return {
      form1,
      form2,
      showEnterEmail: true,
      showEnterPass: false,
      showDone: false,
      showError: false,
      code: '',
      pass: '',
      pass2: '',
      backendresend: false
    }
  },
  methods: {
    doForgot: function () {
      var self = this
      this.$validator.validateAll('form1').then(res => {
        if (res) {
          sendForgot()
        } else {
          self.$root.showModalOK({message: 'Please provide a valid email.'})
        }
      })

      function sendForgot () {
        az.addRemSpinner(true, 'id', 'submit1');
        self.$root.azCognito.sendForgotPasswordCode(self.form1.email, sendForgotCallback)

        function sendForgotCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'submit1');
          if (result == 'success') {
            self.showEnterEmail = false
            self.showEnterPass = true
          } else if (result == 'error') {
            if (obj.code == 'UserNotFoundException') {
              self.$root.showModalOK({message: 'The email provided could not be found.'})
            } else if (obj.code == 'LimitExceededException') {
              self.$root.showModalOK({message: 'The retreive password attemps limit within a time period has been reached. Please try again later.'})
            } else if(obj.message == 'Cannot reset password for the user as there is no registered/verified email or phone_number.'){
              self.$root.showModalOK({message: 'You must verify your email from the link we sent you before resetting your password.'})
            } else if(obj.message == 'User password cannot be reset in the current state.'){
              //do backend user RESEND
             
              function w(d){
                az.addRemSpinner(false, 'id', 'submit1');
                if(d == 'ok'){
                  self.backendresend = true //when account is in FCP state
                  self.showEnterEmail = false
                }
              } function n(){
                az.addRemSpinner(false, 'id', 'submit1');
              }
              az.addRemSpinner(true, 'id', 'submit1');
              self.$root.apiClient.post('api/account/resendactivation', {email: self.form1.email}, w, n)

            }
          }
        }
      }
    },
    doCode: function () {
      var self = this
      this.$validator.validateAll('form2').then(res => {
        if (res) {
          sendChange()
        } else {
          self.$root.showModalOK({message: 'Please correct the errors or omissions on the form.'})
        }
      })

      function sendChange () {
        az.addRemSpinner(true, 'id', 'submit2');
        self.$root.azCognito.doChangePassword(self.form1.email, self.form2.code, self.form2.pass, doChangePwdCallback)

        function doChangePwdCallback (result, err) {
          az.addRemSpinner(false, 'id', 'submit2');
          if (result == 'success') {
            self.showEnterPass = false
            self.showDone = true
            window.scrollTo(0, 0)
          } else if (result == 'error') {
            window.scrollTo(0, 0)
            if (err.code == 'CodeMismatchException' || err.code == 'ExpiredCodeException') {
              self.$root.showModalOK({message: 'The code you provided is invalid.'})
            } else {
              self.showEnterPass = false
              self.showError = true
            }
          }
        }
      }
    },
    openLogin: function () {
      this.$router.push('/')
      this.$root.showModalLogin({message: ''})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Forgot.vue